import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    selector: 'cv-favorite-button-renderer',
    templateUrl: './favorite-button-renderer.component.html',
    styleUrls: ['./favorite-button-renderer.component.scss']
})
export class FavoriteButtonRendererComponent implements AgRendererComponent {
    params: ICellRendererParams;
    addFavoriteTooltip = '';
    removeFavoriteTooltip = '';
    canFavorite: boolean;
    isFavorite: boolean

    constructor() { }

    public agInit(params: ICellRendererParams): void {
        this.params = params;
        const { contextUtil } = params?.context;
        this.addFavoriteTooltip = contextUtil?.getAddFavoriteTooltip();
        this.removeFavoriteTooltip = contextUtil?.getRemoveFavoriteTooltip();
        this.params.eGridCell.addEventListener('keypress', () => this.setFavorite());
        this.isFavorite = this.params.data?.IsFavorite ?? this.params.data?.Favorite;
    }

    public refresh(params: ICellRendererParams): boolean {
        this.params = params;
        this.isFavorite = this.params.data?.IsFavorite ?? this.params.data?.Favorite;
        return true;
    }

    public async setFavorite(): Promise<void> {
        await this.params.context.contextUtil.setFavorite(this.params.data.DashboardID, !this.isFavorite);
    }
}
